import './query_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'controls']
  static classes = ['show']

  connect = (): void => {
    this.checkFilled()
  }

  reset = (): void => {
    this.inputTarget.value = ''
    this.checkFilled()
  }

  resetSize = (): void => {
    this.inputTarget.style.width = null
    this.filtersController.resize()
  }

  checkFilled = (): void => {
    if (this.inputTarget.value.length === 0) {
      this.controlsTarget.classList.remove(this.showClass)
    } else {
      this.controlsTarget.classList.add(this.showClass)
    }
  }

  get updatedWidth (): number {
    return parseInt(this.inputTarget.offsetWidth) + this.availableSpace
  }

  get availableSpace (): number {
    return this.filtersController.availableSpace
  }

  get filtersController (): object {
    return this.navigationController.filtersController
  }

  get navigationController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.navigation'), 'navigation')
  }

  submitForm = (event): void => {
    event.preventDefault()
    this.navigationController.submitForm()
  }
}
